document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('pw-overlay');
  const content = document.getElementById('protected-content');
  if (!overlay || !content) return;

  const PASSWORD = overlay.dataset.password || '';

  const input = document.getElementById('pw-input');
  const btn = document.getElementById('pw-submit');
  const err = document.getElementById('pw-error');

  const lockPage = () => {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
  };

  const unlockPage = () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
  };

  const unlock = () => {
    unlockPage();
    overlay.style.display = 'none';
    content.style.display = 'block';
  };

  const check = () => {
    const val = (input.value || '').trim();
    if (val && val === PASSWORD) {
      sessionStorage.setItem('pageAccess', PASSWORD);
      unlock();
    } else {
      err.hidden = false;
      input.focus();
    }
  };

  lockPage();

  if (sessionStorage.getItem('pageAccess') === PASSWORD && PASSWORD) {
    unlock();
    return;
  }

  btn.addEventListener('click', check);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') check();
  });
});
